import React, { useCallback } from "react";
import clsx from "clsx";
import { useDropzone } from "react-dropzone";

export default function Dropzone({
  width,
  height,
  format,
  minSize,
  maxSize,
  maxFiles,
  onAccepted,
  onRejected,
  isPassportPhoto,
}) {
  const onDropAccepted = useCallback(
    (acceptedFiles) => {
      const [file] = acceptedFiles;
      onAccepted(file);
    },
    [onAccepted]
  );
  const onDropRejected = useCallback(
    (fileRejections) => {
      const [file] = fileRejections;
      onRejected(file);
    },
    [onRejected]
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDropAccepted,
    onDropRejected,
    multiple: false,
    maxFiles,
    minSize: minSize || 0,
    maxSize,
    accept: {
      "image/jpeg": [".jpg", ".jpeg"],
      "image/png": [".png"],
      // "image/gif": [".gif"],
    },
  });

  const formatBytes = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    var k = 1000,
      dm = 0,
      sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  return (
    <div>
      <div
        className={clsx(
          `${width} ${height} border-2 border-dashed rounded bg-blue-50 flex flex-col items-center justify-center text-gray-400 relative`,
          isDragActive ? "border-blue-500" : "border-gray-200"
        )}
        {...getRootProps()}
      >
        <input {...getInputProps()} />
        <svg
          class="w-12 h-12"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
          ></path>
        </svg>
        <p className="text-sm text-center px-4">
          Choose a file or drag it here
        </p>
      </div>
      <div className="mt-3 text-sm">
        <p>File format: jpg / png</p>
        <p>
          File size: {minSize ? `${formatBytes(minSize)} - ` : ""}
          {formatBytes(maxSize)}
        </p>
        {isPassportPhoto && (
          <p>
            Passport photo must meet{" "}
            <a
              href="https://www.eduhk.hk/ecpus/step2.html"
              target="_blank"
              rel="noreferrer"
              className="text-orange-600 hover:text-orange-700 underline"
            >
              several specifications
            </a>
            .
          </p>
        )}
      </div>
    </div>
  );
}
